import React, { useState } from "react";
import styled from "@emotion/styled";
import TtgFeature from "../TtgFeature";

const ToolResponseContainer = styled.div`
  background-color: ${(props) =>
    props.theme.type === "light"
      ? props.theme.gray.gray100
      : props.theme.gray.gray800};
  padding: 8px 12px;
  border-radius: 8px;
  margin: 4px 0;
  font-size: 14px;
  color: ${(props) => props.theme.text.secondary};
  border: none;
  cursor: pointer;

  .tool-response-header {
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${(props) => props.theme.success};
    font-size: 14px;
    font-weight: 500;
    margin-bottom: ${(props) => (props.expanded ? "8px" : "0")};
  }

  .tool-response-content {
    max-height: ${(props) => (props.expanded ? "150px" : "0")};
    font-family: monospace;
    white-space: pre-wrap;
    font-size: 12px;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }
`;

const ToolResponseBlock = ({ content }) => {
  const [expanded, setExpanded] = useState(false);

  if (!content) return null;

  // Try to parse JSON response for better formatting
  let formattedContent = content;
  try {
    const parsed = JSON.parse(content);
    formattedContent = JSON.stringify(parsed, null, 2);
  } catch (e) {
    // Not JSON, use as is
  }

  return (
    <TtgFeature>
      {({ treeIcon }) => (
        <ToolResponseContainer
          expanded={expanded}
          onClick={() => setExpanded(!expanded)}
        >
          <div className="tool-response-header">{treeIcon} Tool response</div>
          <div className="tool-response-content">{formattedContent}</div>
        </ToolResponseContainer>
      )}
    </TtgFeature>
  );
};

export default ToolResponseBlock;
